export const HEADER_HEIGHT = 75;
export const FOOTER_HEIGHT = 40;
export const WRAPPER_PADDING = 16;
export const ZUCK_PLUS_KEY = "has-purchased-zuck-plus";
